module.exports = __webpack_public_path__ + "img/motorbikeOverview1.859c2681.svg";